import { Grid, makeStyles, Paper, Typography } from "@material-ui/core";
import InfoIcon from "src/components/Icon/InfoIcon";
import { THEME_MODE } from "src/config/constants";
import { numberWithCommas, toFixed } from "src/services/utils";

const useStyles = makeStyles((theme) => ({
  label: {
    color: theme.palette.type === THEME_MODE.DARK ? "#FFFFFF" : "#566474",
  },
  value: {
    color: theme.palette.type === THEME_MODE.DARK ? "#6CBCFF" : "#131C23",
    fontSize: "22px",
    fontWeight: 500,
  },
  figure: {
    fontSize: "22px",
    fontWeight: 500,
  },
  depositPaper: {
    background: theme.palette.type === THEME_MODE.DARK ? "#053150" : "#BAD3FF",
  },
  borrowPaper: {
    background: theme.palette.type === THEME_MODE.DARK ? "#202944" : "#E2D6FF",
  },
}));

export default function NetApyData({ totalUserDeposit, totalUserBorrow, netApy }) {
  const cls = useStyles();

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={5}>
        <Paper className={cls.depositPaper}>
          <Typography variant="h5" color="primary" align="center">
            User Deposited <InfoIcon title="The amount of cryptocurrency (in USD) user deposited" />
          </Typography>
          <Typography align="center" className={cls.figure}>
            ${totalUserDeposit !== undefined ? numberWithCommas(toFixed(totalUserDeposit, 2)) : "--"}
          </Typography>
        </Paper>
      </Grid>
      <Grid item xs={12} md={2}>
        <Paper>
          <Typography variant="h5" align="center" className={cls.label}>
            NET APY
          </Typography>
          <Typography align="center" className={cls.value}>
            {isNaN(netApy) ? "--" : numberWithCommas(toFixed(parseFloat(netApy) * 100, 2))}%
          </Typography>
        </Paper>
      </Grid>
      <Grid item xs={12} md={5}>
        <Paper className={cls.borrowPaper}>
          <Typography variant="h5" color="secondary" align="center">
            User Borrowed <InfoIcon title="The amount of cryptocurrency (in USD) user borrowed" />
          </Typography>
          <Typography align="center" className={cls.figure}>
            ${totalUserBorrow !== undefined ? numberWithCommas(toFixed(totalUserBorrow, 2)) : "--"}
          </Typography>
        </Paper>
      </Grid>
    </Grid>
  );
}
